import React from "reactn"

import { Button } from "./button";
import {
  Box,
  Center,
} from '@chakra-ui/react';

import { GbiBridged } from "./gbiBridged"
import PageHeader from "./pageHeader";

export function ColumnCardData({ isStory, columnCardData, eager }) {
  const {
    title,
    subtitle,
    button,
    text,
    image,
    imageGallery,
    mobileimage
  } = columnCardData

  return (
    <Box id="columnCardData">
      {(title || text) &&
        <Center >
          <Box width={["90%", "90%", "75%", "70%"]} marginTop={5}>
            <PageHeader isStory={isStory} title={title} subtitle={subtitle} text={text} />
          </Box>
        </Center>
      }
      {imageGallery &&
        <Box mt={3}>

          {imageGallery.map((gImage, index) => (
            <Center id={`ig${index}`} key={`ig${index}`}>
              <Box id="columnCardimage" position={'relative'} width={['80%','80%','60%','60%']} mb={3} >
                <GbiBridged style={{maxHeight: '200px'}} eager={eager} mobileImageData={null} imageData={gImage.gatsbyImageData} alt={gImage.alt} title={gImage.title} />
              </Box>
            </Center>
          ))
          }
        </Box>
      }
    
      {image && isStory != true ?
        <Box id="columnCardimage" position={'relative'} width={'100%'}>
          <Center>
            <GbiBridged eager={eager} mobileImageData={mobileimage ? mobileimage.gatsbyImageData : null} imageData={image.gatsbyImageData} alt={image.alt} title={image.title} />
          </Center>
          {button && <Button button={button} />}
        </Box>
        :
        <>
          {button && button.length > 0 &&
            <Box id="columnCardButton" position={'relative'} marginBottom={8} marginTop={5} width={'100%'} height={15}>
              <Button button={button} />
            </Box>
          }
        </>
      }
    </Box>

  );
}

